'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).'; }

var InputWrapper = (0, _styledBase2.default)('div', {
	target: 'eiy7zyl0',
	label: 'InputWrapper'
})(process.env.NODE_ENV === 'production' ? {
	name: '1bqnmih',
	styles: 'flex:1;position:relative;'
} : {
	name: '1bqnmih',
	styles: 'flex:1;position:relative;',
	map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvSW5wdXRXcmFwcGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUUrQiIsImZpbGUiOiIuLi8uLi9zcmMvc3R5bGVzL0lucHV0V3JhcHBlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgSW5wdXRXcmFwcGVyID0gc3R5bGVkLmRpdmBcblx0ZmxleDogMTtcblx0cG9zaXRpb246IHJlbGF0aXZlO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgSW5wdXRXcmFwcGVyO1xuIl19 */',
	toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

exports.default = InputWrapper;